import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../../auth/auth-guard.service';
import { DatabasesComponent } from './databases.component';
import { DatabaseComponent } from './database.component';

const routes: Routes = [
  {
    path: '',
    component: DatabasesComponent, canActivate: [AuthGuard],
    data: { permissions: ['adminAccess']},
    children: [

      {
        path: 'liste',
        component:DatabaseComponent,
        canActivate: [AuthGuard],
        data: { permissions: ['adminAccess', 'adminEditUser']},
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LicenceKeysRoutingModule { }

export const routedComponents = [
  DatabasesComponent,
  DatabaseComponent
];
